import { ReactElement } from 'react';
import Services from '~/ui/components/common/Services';
import { productServicesMock } from '~/ui/components/common/Services/servicesMock';
import ProductSEO from '~/ui/components/common/ProductSEO';
import YMALCarousel from '~/ui/components/common/YMALCarousel';
import { IUpsellProduct } from '~/ui/components/common/Swiper/types';
import TestimonialSingleQuote from '../Home/sections/TestimonialsSection/TesmimonialSingleQuote';
import { IBaseProduct } from '@Hotels-at-Home/hah-fe-core/dist/types';

interface ProductExtraContentProps {
  ymalProducts: IUpsellProduct[];
  quote: string;
  product: IBaseProduct;
}

const ProductExtraContent = ({
  ymalProducts,
  quote,
  product,
}: ProductExtraContentProps): ReactElement => (
  <div>
    <Services items={productServicesMock} />
    <div className="product-carousel">
      {!!ymalProducts.length && <YMALCarousel items={ymalProducts} />}
    </div>
    <TestimonialSingleQuote quote={quote} />
    <ProductSEO product={product} />
  </div>
);

export default ProductExtraContent;
